import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import { toString } from 'lodash';

import { api } from '@/api';
import { Pagination, PaginationParams } from '@/common/types';
import { API_URL, IClaimDtoClaimStatusEnum, IClaimParticipantResponseDto } from '@/dtos';


interface ClaimPayload {
  claim_id?: number;
  provider_name?: string;
  service_id?: number;
  service_on?: string;
  requested_amount?: number;
}

interface Claim {
  claimId?: string;
  providerName?: string;
  serviceId?: string;
  serviceOn?: string;
  requestedAmount?: number;
}

interface Props extends Partial<PaginationParams> {
  disabled?: boolean;
}

const useClaimsSearchParticipantQuery = ({ page, perPage, disabled }: Props) => {
  const payload = {
    claim_status: [IClaimDtoClaimStatusEnum.NEEDS_HELP],
    pagination: {
      page: page && page >= 0 ? page - 1 : 0,
      page_size: perPage || 10,
    },
  };

  const { data, isLoading } = useQuery(
    [API_URL.CLAIMS_SEARCH_PARTICIPANT, page, perPage],
    () => api.post<Pagination<IClaimParticipantResponseDto>>(API_URL.CLAIMS_SEARCH_PARTICIPANT, payload),
    {
      enabled: !disabled,
    }
  );

  const claims: Claim[] = useMemo(
    () =>
      data?.data?.content?.map((claim) => ({
        claimId: toString(claim?.claim_id),
        providerName: claim?.provider_name,
        serviceId: toString(claim?.service_id),
        serviceOn: (claim?.service_on || '') as string,
        requestedAmount: claim?.requested_amount,
      })) || [],
    [data]
  );

  return {
    claims,
    total: data?.data?.totalElements || 0,
    isLoading,
  };
};

export default useClaimsSearchParticipantQuery;
